<script setup>
import { useBreakpoints } from "@vueuse/core";

const universityNames = ref([
  "Chulalongkorn University",
  "Mahidol University",
  "Chiang Mai University",
  "Thammasat University",
  "King Mongkut's University of Technology Thonburi",
  "Khon Kaen University",
  "Prince of Songkla University",
  "Kasetsart University",
  "Suranaree University of Technology",
  "King Mongkut's University of Technology North Bangkok",
  "King Mongkut's Institute of Technology Ladkrabang",
  "Mae Fah Luang University",
  "University of the Thai Chamber of Commerce",
  "Siam University",
  "Global Academy",
  "Asian Institute of Hospitality Management AIHM",
  "Southeast Bangkok University",
  "Panyapiwat Institute of Management",
  "Dhurakij Pundit University",
  "Sripatum University",
  "Dusit Thani College",
  "Raffles International College",
  "Stamford International University",
  "Bangkok University International",
  "Rangsit University International College",
  "Krirk University International",
  "CMKL University",
  "Kasem Bundit University",
  "St. Theresa University",
  "Assumption University",
  "Harbour.Space University",
  "Payab University",
  "Walailak University",
  "Maejo University",
  "Naresuan University",
  "Silpakorn University",
  "Srinakharinwirot University",
  "Burapha University",
  "Mahasarakham University",
  "Thai-Nichi Institute of Technology",
  "Mahanakorn University of Technology",
  "ITIM University",
  "North Chiang Mai University",
  "Asia-Pacific International University",
]);

const breakpoints = useBreakpoints(BREAKPOINTS);
const activeBreakpoints = breakpoints.active();

const universityCount = computed(() => {
  switch (activeBreakpoints.value) {
    case "mobile":
      return 20;
    case "desktop":
      return 100;
    default:
      return 100;
  }
});

const queryPayload = computed(() => {
  return universityNames.value
    .map((name, index) => "name_list[" + index + "]=" + name + "&")
    .join("");
});

const { data: universityLists } = usePublicFetch(
  () =>
    `universities/name/list?featured=${true}&page=1&pageSize=${
      universityCount.value
    }`,
  {
    method: "GET",
    key: "footer-university-lists",
  },
);
</script>

<template>
  <p class="text-lg font-bold px-2 lg:px-0">Popular Universities</p>
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-2 gap-x-10 mt-4 px-2 lg:px-0"
  >
    <div v-for="uni in universityLists?.data" :key="uni.id" class="space-y-4">
      <NuxtLink
        :to="`/universities/${uni.slug}`"
        class="text-sm hover:underline"
      >
        {{ uni.name }}
      </NuxtLink>
    </div>
  </div>
</template>
